import React from "react";
import "./styles.scss";
import { Typography } from "@trussle/external-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../../types/IContentfulImage";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { PanelWrapper } from "../../PanelWrapper";
import { GatsbyImageOrSvg } from "../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface ILenderPanelProps{
  title: string,
  subtitleRichText: IContentfulRichTextResponse,
  images: IContentfulImage[] & ImageDataLike[]
}

export const LenderPanel: React.FC<ILenderPanelProps> = ({
  title,
  subtitleRichText,
  images,
}) => (
  <PanelWrapper>
    <div className="lender-panel">
      <div className="lender-panel-content">
        <Typography variant="h2" classes="lender-panel-content-title">
          {title}
        </Typography>
        <div className="lender-panel-content-subtitle">
          <div>{renderRichText(subtitleRichText)}</div>
        </div>
        <div className="lender-panel-content-grid">
          {images.map((img) => {
            const image = img as IContentfulImage & ImageDataLike;
            return (
              <GatsbyImageOrSvg image={image} loading="lazy" alt={img.title} />
            );
          })}
        </div>
      </div>
    </div>
  </PanelWrapper>
);
